import { DialogName, ModalName } from 'app/enums';
import { ApiEntitiesState } from 'app/interfaces/store';
import { ModalStoreStatus } from 'app/store/modal/enums';
import { ModalPayload, ModalsState } from 'app/store/modal/interfaces';

import { entityAdapter } from './adapter';

export const clearAllReducer = (state: ModalsState): void => {
  entityAdapter.removeAll(state);
};

export const openModalReducer = (state: ModalsState, action: { payload: ModalPayload }): void => {
  entityAdapter.addOne(state, action.payload);
};

export const closeModalReducer = (
  state: ModalsState,
  action: { payload: ModalName | DialogName }
): void => {
  entityAdapter.removeOne(state, action.payload);
};

export const closeModalsReducer = (
  state: ModalsState,
  action: { payload: (ModalName | DialogName)[] }
): void => {
  entityAdapter.removeMany(state, action.payload);
};

export const closeAllModalsReducer = (
  state: ModalsState
): ApiEntitiesState<ModalPayload, ModalStoreStatus> => entityAdapter.removeAll(state);
